import { Textarea } from '@clientbase/clientbase-library'
import { Box } from '@mui/material'
import styled from '@mui/system/styled'

export const FormWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
})

export const FormSectionWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  marginBottom: 16
})

export const CustomLabel = styled('label')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  fontSize: '14px',
  marginBottom: '4px',
  color: theme.palette.neutral[200]
}))

export const ExtraFieldsWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 12
})

export const ProductCard = styled(Box)({
  display: 'flex',
  gap: 16,
  padding: 16,
  boxShadow: '0px 2px 10px 0px rgba(0,0,0,0.1)',
  alignItems: 'center',
  position: 'relative',
  borderRadius: 8
})

export const TextAreaCustom = styled(Textarea)({
  overflow: 'auto!important',
  outline: 'none',
  height: '90px',
  '&:focus': {
    outline: 'solid 1px black'
  }
})

export const ImgContainer = styled('div')(() => ({
  borderRadius: '5px'
}))
